"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcSliderDoubleBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var helpers_1 = require("../../../common/helpers");
var bc_slider_constants_1 = require("./bc-slider-constants");
var bc_slider_constants_2 = require("./bc-slider-constants");
var bc_slider_constants_3 = require("./bc-slider-constants");
var bc_slider_constants_4 = require("./bc-slider-constants");
var BcSliderDoubleBehavior = (function (_super) {
    __extends(BcSliderDoubleBehavior, _super);
    function BcSliderDoubleBehavior() {
        return _super.call(this) || this;
    }
    BcSliderDoubleBehavior.setUpAll = function () {
        var tabsElements = Array.from(document.querySelectorAll("div[class^='".concat(bc_slider_constants_3.GROUP_SLIDER_DOUBLE_SUFIX, "']")));
        var elements = [];
        for (var _i = 0, tabsElements_1 = tabsElements; _i < tabsElements_1.length; _i++) {
            var element = tabsElements_1[_i];
            var bc = new BcSliderDoubleBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    };
    BcSliderDoubleBehavior.prototype._setUp = function () {
        var _this_1 = this;
        this.inputL = this.mySelf.querySelector("input[class='bc-slider-dual ".concat(bc_slider_constants_3.GROUP_SUFIX_LEFT, "']"));
        this.inputR = this.mySelf.querySelector("input[class='bc-slider-dual ".concat(bc_slider_constants_2.GROUP_SUFIX_RIGHT, "']"));
        this.inputL.addEventListener('input', function (evt) {
            _this_1.setLeftValue();
            _this_1.returnValue();
        });
        this.thumbLeft = this.mySelf.querySelector("[class='".concat(bc_slider_constants_2.THUMB_LEFT_SLIDER_CLASS, "']"));
        (0, helpers_1.addFocusable)(this.inputL, null, null, [this.thumbLeft]);
        this.setLeftValue();
        this.inputR.addEventListener('input', function (evt) {
            _this_1.setRightValue();
            _this_1.returnValue();
        });
        this.thumbRight = this.mySelf.querySelector("[class='".concat(bc_slider_constants_4.THUMB_RIGHT_SLIDER_CLASS, "']"));
        (0, helpers_1.addFocusable)(this.inputR, null, null, [this.thumbRight]);
        this.setRightValue();
    };
    BcSliderDoubleBehavior.prototype.setValue = function (value) {
        if (value.min && value.max) {
            var auxRight = this.mySelf.querySelector('.input-right');
            var auxLeft = this.mySelf.querySelector('.input-left');
            auxLeft.value = value.min;
            auxRight.value = value.max;
            this.setLeftValue();
            this.setRightValue();
        }
    };
    BcSliderDoubleBehavior.prototype.returnValue = function () {
        if (this.valueL && this.valueR) {
            if (this.outputFunction) {
                this.outputFunction({
                    min: this.valueL,
                    max: this.valueR
                });
            }
        }
    };
    BcSliderDoubleBehavior.prototype.setLeftValue = function () {
        var auxRight = this.mySelf.querySelector('.input-right');
        var self = this.inputL;
        var min = parseInt(self.min);
        var max = parseInt(self.max);
        var newValue = Math.min(parseInt(self.value), parseInt(auxRight.value));
        self.value = newValue.toString();
        var percent = ((newValue - min) / (max - min)) * bc_slider_constants_4.SLIDER_PERCENTAGE;
        var thumbLeft = this.mySelf.querySelector('.slider > .thumb.left');
        var range = this.mySelf.querySelector('.slider > .range');
        thumbLeft.style.left = percent + '%';
        range.style.left = percent + '%';
        this.inputL.style.zIndex = percent > bc_slider_constants_3.SLIDER_N90 ? '4' : '3';
        if (this.thumbLeft) {
            var value = parseInt("".concat((parseInt(thumbLeft.style.left.replace('%', '')) /
                bc_slider_constants_4.SLIDER_PERCENTAGE) *
                (this.inputL.offsetWidth - bc_slider_constants_1.SLIDER_N24)));
            this.valueL = value;
            this.thumbLeft.style.left = "".concat(value, "px");
        }
    };
    BcSliderDoubleBehavior.prototype.setRightValue = function () {
        var auxLeft = this.mySelf.querySelector('.input-left');
        var _this = this.inputR, min = parseInt(_this.min), max = parseInt(_this.max);
        var newValue = Math.max(parseInt(_this.value), parseInt(auxLeft.value));
        _this.value = newValue.toString();
        var percent = ((newValue - min) / (max - min)) * bc_slider_constants_4.SLIDER_PERCENTAGE;
        var thumbRight = this.mySelf.querySelector('.slider > .thumb.right');
        var range = this.mySelf.querySelector('.slider > .range');
        thumbRight.style.right = bc_slider_constants_4.SLIDER_PERCENTAGE - percent + '%';
        range.style.right = bc_slider_constants_4.SLIDER_PERCENTAGE - percent + '%';
        this.inputR.style.zIndex = percent < bc_slider_constants_1.SLIDER_N10 ? '4' : '3';
        if (this.thumbRight) {
            var value = parseInt("".concat((parseInt(thumbRight.style.right.replace('%', '')) /
                bc_slider_constants_4.SLIDER_PERCENTAGE) *
                (this.inputR.offsetWidth - bc_slider_constants_1.SLIDER_N24)));
            this.valueR = value;
            this.thumbRight.style.right = "".concat(value - bc_slider_constants_1.SLIDER_N14, "px");
        }
    };
    return BcSliderDoubleBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcSliderDoubleBehavior = BcSliderDoubleBehavior;
